import React, {Component} from "react";
import FormField from "../../../components/form/FormField";
import SignatureInput from "../../../components/signature-input/SignatureInput";
import TextInput from "../../../components/text-input/TextInput";
import moment from "moment";
import TeleconsultationFormTextEnum from "../teleconsultation/enum/TeleconsultationFormTextEnum";
import FormLanguages from "../enum/FormLanguages";
import {isMinor} from "../../patient/Patient";
import SignatureDisplay from "../../../components/signature-input/SignatureDisplay";
import {YesNoRadioInput} from "./YesNoRadioInput";

export default class PublicTeleconsultationWizardPage extends Component {

    /**
     * Handle field changes with proper form name reference
     * @param {string} fieldName - Name of the field to update
     * @param {*} value - New value for the field
     */
    handleFieldChange = (fieldName, value) => {
        const { fieldChanged } = this.props;

        if (fieldChanged) {
            fieldChanged('teleconsultationConsentForm', fieldName, value);
        }
    }

    /**
     * Get localized text based on the current language
     * @param {string} key - The key to look up in the text enum
     * @returns {string} - The localized text
     */
    getLocalizedText = (key) => {
        const { language } = this.props;
        const selectedLanguage = language || FormLanguages.ENGLISH.name;
        return TeleconsultationFormTextEnum[key] ? TeleconsultationFormTextEnum[key][selectedLanguage] : '';
    }

    render() {
        const {
            form,
            formBodyClass = '',
            formFields,
            patientName,
            patientDOB,
            enumLabel
        } = this.props;

        const isPatientMinor = isMinor(patientDOB, 'UAE');

        return (
            <div className={formBodyClass + ' m-4'}>
                <h3 className={'text-center mb-4'}>
                    {this.getLocalizedText('Teleconsultation_Consent_Form_Title')}
                </h3>

                <p>
                    {this.getLocalizedText('Treatment_Consideration')}
                </p>

                <p><b>{this.getLocalizedText('Electronic_Systems')}</b><br />
                    {this.getLocalizedText('Electronic_Systems_Description')}
                </p>

                <p><b>{this.getLocalizedText('Nature_Of_Teleconsultation')}</b><br />
                    {this.getLocalizedText('Nature_Of_Teleconsultation_Description')}
                    <ul className={"list-unstyled"}>
                        <li>
                            <p><span className={"mr-2 d-inline font-weight-bold"}>a.</span>
                                {this.getLocalizedText('Nature_Of_Teleconsultation_Point1')}
                            </p>
                        </li>
                        <li>
                            <p><span className={"mr-2 d-inline font-weight-bold"}>b.</span>
                                {this.getLocalizedText('Nature_Of_Teleconsultation_Point2')}
                            </p>
                        </li>
                    </ul>
                </p>

                <p><b>{this.getLocalizedText('Medical_Information_And_Records')}</b>
                    {this.getLocalizedText('Medical_Information_Description')}
                </p>

                <p><b>{this.getLocalizedText('Confidentiality')}</b>
                    {this.getLocalizedText('Confidentiality_Description')}
                </p>

                <p><b>{this.getLocalizedText('Rights')}</b>
                    {this.getLocalizedText('Rights_Description')}
                </p>

                <p><b>{this.getLocalizedText('Expected_Benefits')}</b><br />
                    <ul className={"list-unstyled"}>
                        <li>
                            <p><span className={"mr-2 d-inline font-weight-bold"}>a.</span>
                                {this.getLocalizedText('Expected_Benefits_Point1')}
                            </p>
                        </li>
                        <li>
                            <p><span className={"mr-2 d-inline font-weight-bold"}>b.</span>
                                {this.getLocalizedText('Expected_Benefits_Point2')}
                            </p>
                        </li>
                    </ul>
                </p>
                <p><b>{this.getLocalizedText('Possible_Risks')}</b><br />
                    {this.getLocalizedText('Possible_Risks_Description')}
                    <ul className={"list-unstyled"}>
                        <li>
                            <p><span className={"mr-2 d-inline font-weight-bold"}>a.</span>
                                {this.getLocalizedText('Possible_Risks_Point1')}
                            </p>
                        </li>
                        <li>
                            <p><span className={"mr-2 d-inline font-weight-bold"}>b.</span>
                                {this.getLocalizedText('Possible_Risks_Point2')}
                            </p>
                        </li>
                        <li>
                            <p><span className={"mr-2 d-inline font-weight-bold"}>c.</span>
                                {this.getLocalizedText('Possible_Risks_Point3')}
                            </p>
                        </li>
                        <li>
                            <p><span className={"mr-2 d-inline font-weight-bold"}>d.</span>
                                {this.getLocalizedText('Possible_Risks_Point4')}
                            </p>
                        </li>
                    </ul>
                </p>

                <p><b>{this.getLocalizedText('Questions_And_Concerns')}</b><br />
                    {this.getLocalizedText('Questions_And_Concerns_Section1_Description')}
                </p>

                <p>
                    <ul className={"list-unstyled"}>
                        <li>
                            <p><span className={"mr-2 d-inline font-weight-bold"}>a.</span>
                                {this.getLocalizedText('Questions_And_Concerns_Section1_Point1')}
                            </p>
                        </li>
                        <li>
                            <p><span className={"mr-2 d-inline font-weight-bold"}>b.</span>
                                {this.getLocalizedText('Questions_And_Concerns_Section1_Point2')}
                            </p>
                        </li>
                        <li>
                            <p><span className={"mr-2 d-inline font-weight-bold"}>b.</span>
                                {this.getLocalizedText('Questions_And_Concerns_Section1_Point3')}
                            </p>
                        </li>
                    </ul>
                </p>

                <p>
                    {this.getLocalizedText('Questions_And_Concerns_Section2_Description')}
                    <ul className={"list-unstyled"}>
                        <li>
                            <p><span className={"mr-2 d-inline font-weight-bold"}>a.</span>
                                {this.getLocalizedText('Questions_And_Concerns_Section2_Point1')}
                            </p>
                        </li>
                        <li>
                            <p><span className={"mr-2 d-inline font-weight-bold"}>b.</span>
                                {this.getLocalizedText('Questions_And_Concerns_Section2_Point2')}
                            </p>
                        </li>
                        <li>
                            <p><span className={"mr-2 d-inline font-weight-bold"}>c.</span>
                                {this.getLocalizedText('Questions_And_Concerns_Section2_Point3')}
                            </p>
                        </li>
                        <li>
                            <p><span className={"mr-2 d-inline font-weight-bold"}>d.</span>
                                {this.getLocalizedText('Questions_And_Concerns_Section2_Point4')}
                            </p>
                        </li>
                        <li>
                            <p><span className={"mr-2 d-inline font-weight-bold"}>e.</span>
                                {this.getLocalizedText('Questions_And_Concerns_Section2_Point5')}
                            </p>
                        </li>
                    </ul>
                </p>
                <p>
                    {this.getLocalizedText('Questions_And_Concerns_Section3_Description')}
                    <ul className={"list-unstyled"}>
                        <li>
                            <p><span className={"mr-2 d-inline font-weight-bold"}>a.</span>
                                {this.getLocalizedText('Questions_And_Concerns_Section3_Point1')}
                            </p>
                        </li>
                        <li>
                            <p><span className={"mr-2 d-inline font-weight-bold"}>b.</span>
                                {this.getLocalizedText('Questions_And_Concerns_Section3_Point2')}
                            </p>
                        </li>
                        <li>
                            <p><span className={"mr-2 d-inline font-weight-bold"}>c.</span>
                                {this.getLocalizedText('Questions_And_Concerns_Section3_Point3')}
                            </p>
                        </li>
                        <li>
                            <p><span className={"mr-2 d-inline font-weight-bold"}>d.</span>
                                {this.getLocalizedText('Questions_And_Concerns_Section3_Point4')}
                            </p>
                        </li>
                    </ul>
                </p>

                <div style={{ border: "1px solid #000000", margin: "10px 0px", display: "flex" }}>
                    <div style={{ flex: 1, margin: "10px 15px" }}>
                        <p><b>{this.getLocalizedText('Final_Consent_Statement')}</b></p>
                    </div>
                    <div style={{ borderLeft: "1px solid #000000", padding: "10px" }}>
                        <p className="display-flex">
                            <FormField ref={this.props.pushFormFieldRef} required
                                requiredMessage={this.getLocalizedText('Field_Required')}
                                validateOn={form.participateInTeleconsultation}>
                                <YesNoRadioInput id="participateInTeleconsultation"
                                                 value={form.participateInTeleconsultation} enumLabel={enumLabel}
                                                 onValueChange={(value) => this.handleFieldChange('participateInTeleconsultation', value)}/>
                            </FormField>
                        </p>
                    </div>
                </div>

                <div className="container">
                    <div className="row">
                        <div className="col-md-3 dim14-form-label">
                            {this.getLocalizedText('Date')}
                        </div>
                        <div className="col-md-3 dim14-base-input">
                            {moment(new Date(form.patientDate)).format('MMMM DD, YYYY')}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3 dim14-form-label">
                            {this.getLocalizedText('Patient_Name')}
                        </div>
                        <div className="col-md-3 dim14-base-input">
                            {patientName}
                        </div>
                        <div className="col-md-3 dim14-form-label">
                            {this.getLocalizedText('Provider_Name')}
                        </div>
                        <div className="col-md-3 dim14-base-input">
                            <FormField ref={this.props.pushFormFieldRef} validateOn={form.providerName}
                                required requiredMessage={this.getLocalizedText('Field_Required')}>
                                <TextInput value={form.providerName} disabled />
                            </FormField>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3 dim14-form-label">
                            {this.getLocalizedText('Print_Name')}
                        </div>
                        <div className="col-md-3 dim14-base-input">
                            <FormField ref={this.props.pushFormFieldRef}
                                disabled={!isPatientMinor}
                                required requiredMessage={this.getLocalizedText('Field_Required')}
                                validateOn={form.guardianName}>
                                <TextInput value={form.guardianName} alphabeticOnly
                                    onChange={(value) => this.handleFieldChange('guardianName', value)} />
                            </FormField>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-3 dim14-form-label">
                            {this.getLocalizedText('Relationship_To_Patient')}
                        </div>
                        <div className="col-md-3 dim14-base-input">
                            <FormField ref={this.props.pushFormFieldRef}
                                disabled={!isPatientMinor}
                                required requiredMessage={this.getLocalizedText('Field_Required')}
                                validateOn={form.guardianRelationship}>
                                <TextInput value={form.guardianRelationship} alphabeticOnly
                                    onChange={(value) => this.handleFieldChange('guardianRelationship', value)} />
                            </FormField>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 dim14-form-label">
                            {this.getLocalizedText('Patient_Signature')}
                        </div>
                        <div className="col-md-6 dim14-form-label">
                            {this.getLocalizedText('Provider_Signature')}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <FormField ref={this.props.pushFormFieldRef}
                                required requiredMessage={this.getLocalizedText('Signature_Required')}
                                validateOn={form.patientSignature}>
                                <SignatureInput signature={form.patientSignature}
                                    onClear={() => this.handleFieldChange('patientSignature', null)}
                                    onSave={(signature) => this.handleFieldChange('patientSignature', signature)} />
                            </FormField>
                        </div>
                        <div className="col-md-6">
                            <FormField ref={this.props.pushFormFieldRef} validateOn={form.providerSignature}
                                required requiredMessage={this.getLocalizedText('Signature_Required')}>
                                <SignatureDisplay signature={form.providerSignature} />
                            </FormField>
                        </div>
                    </div>
                </div>

                {/* Witness/Guardian Section - Required for minor patients */}
                <p className="font-weight-bold">
                    <u>{this.getLocalizedText('Official_Use_Only')}</u></p>
                <p className="font-weight-bold">
                    {this.getLocalizedText('Witness_Statement_Header')}</p>
                <p><i>{this.getLocalizedText('Witness_Statement')}</i></p>

                <div style={{ border: "1px solid", borderRadius: "5px", padding: "30px" }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 dim14-form-label">
                                {this.getLocalizedText('Witness_Name')}
                            </div>
                            <div className="col-md-6 dim14-base-input">
                                <TextInput value={form.witnessName} alphabeticOnly
                                    onChange={(value) => this.handleFieldChange('witnessName', value)} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">{this.getLocalizedText('Witness_Signature')}</div>
                            <div className="col-md-6">
                                <SignatureInput signature={form.witnessSignature}
                                    onClear={() => this.handleFieldChange('witnessSignature', null)}
                                    onSave={(signature) => this.handleFieldChange('witnessSignature', signature)} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
} 